<template>
  <div class="account-vacancies-responses">
    <div v-show="vacancies.length">
      <VacanciesResponsesHeader ref="header" :key="counterKey" />

      <div v-if="!loading.list" :key="counterKey + 1">
        <VacancyResponsesCard
          v-for="vacancy in vacancies"
          :key="vacancy.vacancy.ID"
          :response-vacancy="vacancy"
          @open-resume-phone="onResumePhoneOpen"
        />
      </div>
    </div>

    <div class="account-vacancies-responses__load-more-target">
      <BasePreloader v-if="loading.list || loading.listMore" class="pt-12 pb-12" />
    </div>

    <div v-if="!vacancies.length && !loading.list" class="my-vacancies-list__empty">
      <picture class="my-vacancies-list__empty-bg">
        <img src="@/assets/img/empty-resume-base.svg" alt="bg">
      </picture>
      <h3 class="my-vacancies-list__empty-title">{{ $tMyResponses('Vacancies responses list is empty') }}</h3>
      <div class="my-vacancies-list__empty-text">
        {{ $tMyResponses('Wait for someone who will respond') }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VacanciesResponsesHeader from '@/components/vacanciesResponses/VacanciesResponsesHeader';
import VacancyResponsesCard from '@/components/vacanciesResponses/VacancyResponsesCard';

export default {
  name: 'AccountVacanciesResponses',
  components: {
    VacanciesResponsesHeader,
    VacancyResponsesCard,
  },
  data() {
    return {
      counterKey: 0,
      unsubscribeFromUpdates: null,
      intersectionObserver: null,
    };
  },
  computed: {
    ...mapGetters({
      vacancies: 'vacancies/responses/list',
      loading: 'vacancies/responses/loading',
    }),
  },
  watch: {
    $route() {
      this.counterKey++;
    },
  },
  mounted() {
    this.bindObserverTarget();

    this.unsubscribeFromUpdates = this.$store.subscribeAction(({ type }) => {
      if (type === 'user/updateResumesCount') {
        this.$refs.header?.updateVacancies();
      }
    });
  },
  beforeDestroy() {
    this.unbindObserverTarget();
    this.unsubscribeFromUpdates();
  },
  methods: {
    ...mapActions('vacancies/responses', [
      'loadMore',
    ]),
    bindObserverTarget() {
      const targetEl = this.$el.querySelector('.account-vacancies-responses__load-more-target');

      const onTrigger = ([data]) => {
        if (data.isIntersecting) this.loadMore();
      };

      this.intersectionObserver = new IntersectionObserver(onTrigger, { rootMargin: '200px' });
      this.intersectionObserver.observe(targetEl);
    },
    unbindObserverTarget() {
      this.intersectionObserver?.disconnect();
    },
    onResumePhoneOpen() {
      this.$refs.header.phonesStats.shown++;
      this.$refs.header.phonesStats.available--;
    },
  },
};
</script>
